import { catalogByPart } from "../../../../apis/apiCatalogues";

export const getSelectionChain = async ({
  catalogue,
  isOwn,
  value,
  nestNum = 0,
  forEdition = false,
  separator
}) => {
  const selections = await recursiveSelectionChain({
    catalogue,
    isOwn,
    value,
    nestNum,
    forEdition,
    selections: [],
  });
  return separator ? selections.join(separator) : selections;
};

const recursiveSelectionChain = async ({
  catalogue,
  isOwn,
  value,
  nestNum = 0,
  forEdition = false,
  selections = []
}) => {
  try {
    const splitedAnsr = value.split("::");
    const slicedAnsr = splitedAnsr.slice(0, nestNum * 2);
    const joined = slicedAnsr.join("::");
    const slicedAnsrKey = splitedAnsr.slice(nestNum * 2, 2 * (nestNum + 1));
    const selected = slicedAnsrKey.length === 2 ? slicedAnsrKey[slicedAnsrKey.length - 1] : "";
    const resp = await catalogByPart({
      is_own: isOwn,
      catalogue,
      path: joined ? joined : "/",
      ...(forEdition && { show_all: true }),
    });
    if (resp.error) throw new Error("Error at getting chain of selections");
    if (selected) {
      const newResp = resp.data.find((item) => item.key == selected);
      const newSelections = [...selections, newResp?.label];
      return await recursiveSelectionChain({
        catalogue,
        isOwn,
        value,
        nestNum: nestNum + 1,
        forEdition,
        selections: newSelections,
      });
    } else {
      return selections;
    }
  } catch (error) {
    console.error("Error in recursiveSelectionChain:", error);
    return selections;
  }
}